export default __webpack_public_path__ + "ef0502e49d98619b219b074f3ef7f917.png";